import React, { Component } from 'react';
import ShippingAddressForm from './components/shipping-address-form';
import SettingsContainer from '../../components/settings-container';
import './index.css';

export default class ShippingAddressPage extends Component {
  render() {
    return (
      <SettingsContainer
        className="current-height-page"
        pageTitle="What's your Address?"
        save={ this.save }
        hideSkip={ false }
        isValid= { true }
      >
        <ShippingAddressForm className="optional-shipping" skipSubscription={ true } />
      </SettingsContainer>
    );
  }
}
